import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import Hero from './components/Hero';
import StorySection from './components/StorySection';
import FeaturesSection from './components/FeaturesSection';
import DeveloperSection from './components/DeveloperSection';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <StorySection />
      <FeaturesSection />
      <DeveloperSection />
      <Footer />
    </div>
  );
}